<template>
    <div class="block-progress">
        <span class="block-progress__title">
            Интересы <br> и развитие
        </span>
        <p class="block-progress__text">
            Семилетний ребенок все так же любит своих единорогов, пони, лего и машинки. Но его жизнь теперь делится на четверти и каникулы, успехи измеряются оценками, а интересы подчинены школьной программе. Первокласснику надо привыкнуть к новой жизни, и это может занять целый учебный&nbsp;год.
            <br>
            <br>
            Адаптация во многом зависит от здания школы. Современные учебные комплексы совсем не похожи на советские постройки. В новых школах есть зоны для отдыха, много света и приятные интерьеры. Все вместе влияет на желание учится. Так, ПИК сразу проектирует микрорайоны с учетом детей. Детский сад и школа — здесь <a href="https://www.pik.ru/deti/schools?utm_source=pikabu.ru&utm_campaign=general&utm_medium=referral&utm_content=timeline" class="app__link app__link--red" target="_blank">единый комплекс недалеко от дома</a>. Главное, от самих зданий не веет прошлым&nbsp;веком.
        </p>
        <div class="block-progress__img-box">
            <img
                srcset="../assets/612-img-1b.jpg, ../assets/612-img-1b@2x.jpg 2x"
                src="../assets/612-img-1b.jpg"
                class="block-progress__img"
            />
            <div class="image-caption image-caption--overlap-left" style="text-align:left">Школа в проекте «Бунинские луга»</div>
        </div>
        <p class="block-progress__text block-progress--text-bottom">
            Из рассеянного первоклассника, который приходил на уроки без ручки и сменки, ребенок постепенно становится усидчивым и собранным (хотя иногда процесс растягивается до 11 класса). К концу начальной школы он сильно взрослеет. Начинает меняться тело, появляются первые признаки подросткового кризиса. И вот наступает момент, когда ваш воспитанный мальчик или улыбчивая девочка впервые вам хамит. И это только начало большой битвы за самостоятельность.
        </p>
        <BlockParallax class="block-progress__icon-box block-progress__nb block-progress--icon-desktop" speed="10" direction="right" transform="rotate">
            <img
                src="@/assets/images/icons/nb-2.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__bag block-progress--icon-desktop" speed="8" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/bag.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <div class="block-progress__icon-box block-progress__five-yellow">
            <img
                src="@/assets/images/icons/612-five-yellow.png"
                class="block-progress__icon"
            >
        </div>
        <BlockParallax class="block-progress__icon-box block-progress--icon-desktop block-progress__nb-two" speed="10" direction="left" transform="rotate">
            <img
                src="@/assets/images/icons/nb-2.png"
                class="block-progress__icon"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
// import ImageSlider from './slider'

export default {
    components: {
        BlockParallax
        // ImageSlider
    }
}
</script>

<style scoped lang="stylus">
    .block-progress {
        position relative
        +layout-sm-and-up() {
            display flex
            padding 0
            flex-wrap wrap
        }
        +layout-md-and-up() {
            margin-left 8rem
        }

        &__title {
            display block
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-text
            +layout-sm-and-up() {
                text-align center
                width 100%
                padding-right 7%
                font-size 3rem
                line-height 3.5rem
            }
            +layout-md-and-up() {
                margin-top 2rem
                text-align left
                position absolute
                left 0
                padding-left 0
            }

            br {
                display none
                +layout-md-and-up() {
                    display block
                }
            }
        }

        &__img-box {
            margin 2rem -1rem 0

            +layout-sm-and-up() {
                width 100%
                margin-left 0
                margin-right 0
            }

            +layout-md-and-up() {
                width 100%
                margin 5rem 8rem 4rem 0
            }
        }
        
        &__icon-box {
            position absolute
        }

        &__slider-box {
            margin 2rem 2rem 0

            +layout-sm-and-up() {
                width 100%
                margin 2rem auto 1rem
                max-width 78rem
            }

            +layout-md-and-up() {
                width 100%
                margin 4rem 8rem 3rem 0
            }
        }

        &__img {
            width 100%
            height auto
        }

        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.7rem 0 0 0

            +layout-sm-and-up() {
                width 100%
            }

            +layout-md-and-up() {
                padding-left 25rem
                padding-right 14rem
            }
        }
        &--text-bottom {
            +layout-md-and-up() {
                padding-right 16rem
            }
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__five-yellow {
            position absolute
            top 26%
            right -1%
            width 2.6rem

            +layout-md-and-up() {
                top auto
                left auto
                right -1rem
                width 5rem
                bottom 21rem
            }
        }

        &__bag {
            left 0
            bottom 40rem
            width 6rem
            transform rotate(-13deg)
            z-index 5
            +layout-md-and-up() {
                bottom 15rem
                left -22rem
                width 14rem
                height 16rem
                transform none
                z-index 0
            }
        }

        &__nb {
            position absolute
            bottom 40rem
            right 1rem
            width 5rem
            transform rotate(-66deg)
            +layout-md-and-up() {
                right auto
                left -1rem
                bottom 7rem
                width 8rem
            }
        }

        &__nb-two {
            +layout-md-and-up() {
                position absolute
                right -6.3rem
                top 19.9rem
                width 10rem
            }
        }

        &__circle-yellow {
            width 3.4rem
            height 3.4rem
            position absolute
            top 42%
            left 0
            transform rotate(-147deg)

            +layout-md-and-up() {
                top 29rem
                left -8rem
                width 5.4rem
                height 5.4rem
            }
        }
    }
</style>
